import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,  HttpRequest,
  HttpEventType,
  HttpEvent } from '@angular/common/http';
import { map, tap, last } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { JWTTokenService } from './jwt.token.service';
import { getAuth, onIdTokenChanged } from 'firebase/auth';

const httpOptionsFileUpload = {
  headers: new HttpHeaders().delete('Content-Type')
} 
let httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
} 
const httpOptionsWithOutToken = {
  headers: new HttpHeaders({
    'Accept': 'application/json',
    'skip': 'true'
  })
}
@Injectable({
  providedIn: 'root'
})

export class ApiService {
  public progressSource = new BehaviorSubject<number>(0);
  basePictureURL:string = environment.basePictureURL;
  baseURL: string = environment.baseURL;
  baseURLv2: string = (environment as any).baseURLv2 ?? environment.baseURL;
  DeactivateUsersURL: string =  this.baseURL + 'users/deactivate';
  AllEmployeesURL: string =  this.baseURL + 'employee';
  AllEmployersURL: string =  this.baseURL + 'employer';
  EmployeeProfileURL: string =  this.baseURL + 'employee/profile';
  SearchEmployeesURL: string =  this.baseURL + 'employee/filter';
  SearchEmployeesNameURL: string =  this.baseURL + 'employee/filter_by_name';
  UploadEmployerProfilePicURL: string =  this.baseURL + 'employer/update_profile_pic';
  UploadEmployeeProfilePicURL: string =  this.baseURL + 'employee/update_profile_pic';
  UploadEmployeeIDURL: string =  this.baseURL + 'employee/upload_id';
  UploadEmployeeCerficateURL: string =  this.baseURL + 'employee/upload_certificate';
  UploadEmployeResumeURL: string =  this.baseURL + 'employee/cv';
  EmployeeSearchURL: string =  this.baseURL + 'employee/keyword';
  EmployerProfileURL: string =  this.baseURL + 'employer/profile';
  FavoriteURL: string =  this.baseURL + 'employer/favorite';
  EmployerUpdateProfileURL: string =  this.baseURL + 'employer/update_profile';
  EmployeeUpdateProfileURL: string =  this.baseURL + 'employee/update_profile';
  CategoriesURL: string =  this.baseURL + 'categories';
  SubCategoriesURL: string =  this.baseURL + 'sub_categories';
  UsersByCategoryURL: string =  this.baseURL + 'categories/freelancers_or_jobs';
  SkillsetsURL: string =  this.baseURL + 'skill_sets';
  EducationLevelsURL: string =  this.baseURL + 'education_level';
  JobsURL: string =  this.baseURL + 'jobs';
  SearchJobsURL: string =  this.baseURL + 'jobs/filter';
  JobsIPostedURL: string =  this.baseURL + 'jobs/my_posts';
  JobApplyURL: string =  this.baseURL + 'jobs/apply';
  OfferForJobURL: string =  this.baseURL + 'jobs/show_offers';
  JobApplyByStatusURL: string =  this.baseURL + 'apply/show_applicants_by_status';
  HireApplicantURL: string =  this.baseURL + 'jobs/hire/';
  SaveJobsURL: string =  this.baseURL + 'jobs/save';
  MySavedJobsURL: string =  this.baseURL + 'jobs/my_saved_jobs';
  ApplicantsURL: string =  this.baseURL + 'apply';
  JobsIAppliedForURL: string =  this.baseURL + 'apply/lists_applied';
  JobsIAppliedByStatusForURL: string =  this.baseURL + 'apply/show_by_status';
  OfferURL: string =  this.baseURL + 'offer';
  AllOffersByEmployeeURL: string =  this.baseURL + 'offer/employee/show';
  AllOffersToEmployerURL: string =  this.baseURL + 'offer/employer/show';
  MyWalletURL: string =  this.baseURL + 'wallet_transaction/my_transactions';
  RechargeMyWalletURL: string =  this.baseURL + 'wallet_transaction/pay';
  PendingRechargeWalletURL: string =  this.baseURL + 'wallet_transaction/check_payment_status';
  BankURL: string =  this.baseURL + 'bank';
  MyBankURL: string =  this.BankURL + '/myBank';
  MyWiseURL: string =  this.BankURL + '/myWiseAccount';
  WiseURL: string =  this.baseURL + 'wise_transfer';
  CreateBankRecipientURL: string =  this.WiseURL + '/create_recipients';
  CreateWiseRecipientURL: string =  this.WiseURL + '/create_wise_recipients';
  WithdrawBalanceURL: string =  this.WiseURL + '/withdraw_money';
  WithdrawWiseURL: string =  this.WiseURL + '/wise_to_wise';
  MyEducationDataURL: string =  this.baseURL + 'education_data';
  MyWorkExperienceURL: string =  this.baseURL + 'work_experience';
  PackagesURL: string =  this.baseURL + 'package';
  MyPackagesURL: string =  this.baseURL + 'package_subscription/my_subscription';
  BuyPackagesURL: string =  this.baseURL + 'package_subscription/buy';
  UnsubscribeEmailURL: string =  this.baseURL + 'package_subscription/unsubscribe_to_email';
  ContractsURL: string =  this.baseURL + 'contract';
  MyContractsURL: string =  this.baseURL + 'contract/show_me_my_contract';
  RaiseDisputeURL: string =  this.baseURL + 'contract/raise_dispute';
  RatingURL: string =  this.baseURL + 'contract/give_rating';
  DeliveryURL: string =  this.baseURL + 'deliver';
  ChatURL: string =  this.baseURL + 'chat';
  MyChatsURL: string =  this.baseURL + 'chat/show';
  MyAdminSettingsURL: string =  this.baseURL + 'site_settings';
  SpecificConversationURL: string =  this.baseURL + 'chat/conversation';
  NotificationsURL: string =  this.baseURL + 'notification/';
  MyNotificationsURL: string =  this.baseURL + 'notification/show';
  AllNotificationCounterURL: string =  this.baseURL + 'notification/counts_for_notification_and_messages';
  ContentsURL: string =  this.baseURL + 'content/show_pages';
  BadgesURL: string =  this.baseURL + 'badge';
  CoinsURL: string =  this.baseURL + 'Coin';
  CoinsSettingURL: string =  this.baseURL + 'coin_setting';
  MyCoinsURL: string =  this.baseURL + 'employee/coin';
  MyFreelancerAnalyticsURL: string =  this.baseURL + 'employee/analytics';
  MyClientAnalyticsURL: string =  this.baseURL + 'employer/analytics';
  MyFreelancerApplicationAnalyticsURL: string =  this.baseURL + 'apply/analytics';
  ServiceChargesURL: string =  this.baseURL + 'service_charge';
  DeviceURL: string =  this.baseURL + 'device';
  BlogsURL: string =  this.baseURL + 'blog';
  ConnectsURL: string =  this.baseURLv2 + 'connect';
  EndorsmentURL: string =  this.baseURLv2 + 'endorse';
  BoostURL: string = this.baseURLv2 + 'boost';
  ChallengeURL: string = this.baseURLv2 + 'challenge';
  MyProfileViewersURL: string = this.baseURLv2 + 'profile_view';
  ProURL: string = this.baseURLv2 + 'pro';
  ReferralURL: string = this.baseURL + 'referal_code';
  MakeInvoicePaymentURL: string = this.baseURLv2 + 'invoice/';
  // GET /invoice/me?page=1
  getMyInvoicesURL: string = this.baseURLv2 + 'invoice/me';
  isLoggedIn = false;
  isUserEmployee = false;
  isUserEmployer = false;
  redirectUrl: string | undefined;
  isAuthenticatedSrc: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  roleAs!: string | null;
  
  constructor(private http: HttpClient) {
    // Set up a global Firebase token refresh listener (browser only)
    if (typeof window !== 'undefined') {
      const auth = getAuth();
      onIdTokenChanged(auth, async (user) => {
        if (user) {
          const token = await user.getIdToken();
          localStorage.setItem('GProToken', JSON.stringify(token));
        } else {
          localStorage.removeItem('GProToken');
        }
      });
    }
  }

  public getToken(): string {
    // firebase.auth().currentUser.getIdToken(true).then(function(idToken) {
    //     localStorage.setItem('GProToken', JSON.stringify(idToken));
    //   }).catch(function(error) {
    //     console.log(error);
    //   });
    if (typeof window === 'undefined') {
      return null as any;
    }
    let GPoToken = (JSON.parse(localStorage.getItem('GProToken') || 'null'));
    if(GPoToken !== null){
      return GPoToken;
    }else{
      return null as any;
    }
  }
  deleteConversation(id: string): Observable<any[]> {
    return this.http.delete<any>(this.ChatURL + '/' + id, httpOptions);
  }
  postSendChat(file: any, data: any):Observable<any[]> {
    if(file){
      const httpOptionsFileUploadChat = {
        headers: new HttpHeaders().delete('Content-Type'),
        reportProgress: true,
        observe: 'events' as 'body'
      };
      let formData = new FormData();
      formData.append("attachement", file);
      formData.append("customer_id", data.customer_id);
      formData.append("chat", data.chat);
      return this.http.post<any>(this.ChatURL,formData,httpOptionsFileUploadChat);
    }else{
      const httpOptionsFileUploadChat = {
        headers: new HttpHeaders().delete('Content-Type'),
        reportProgress: true,
        observe: 'events' as 'body'
      };
      return this.http.post<any>(this.ChatURL, data, httpOptionsFileUploadChat);
    }
  }

  // postSendChat(data: any): Observable<any[]> {
  //   return this.http.post<any>(this.ChatURL, data, httpOptions);
  // }
  createDevice(data: any,): Observable<any[]> {
    return this.http.post<any>(this.DeviceURL,data, httpOptions);
  }
  searchJobs(data: any,params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    const payload = data && typeof data === 'object' ? { ...data } : data;
    if (payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'from')) {
      delete payload.from;
    }
    return this.http.post<any>(this.SearchJobsURL, payload, options);
  }
  searchFreelancers(data: any,params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.post<any>(this.EmployeeSearchURL,data, options);
  }
  deactivateAccount(): Observable<any[]> {
    return this.http.get<any>(this.DeactivateUsersURL, httpOptions);
  }
  getServiceCharges(): Observable<any[]> {
    return this.http.get<any>(this.ServiceChargesURL, httpOptions);
  }
  getBadges(): Observable<any[]> {
    return this.http.get<any>(this.BadgesURL, httpOptionsWithOutToken);
  }
  getContents(data: any): Observable<any[]> {
    return this.http.get<any>(this.ContentsURL + '?page='+ data.page  + '&position=' + data.position, httpOptionsWithOutToken);
  }
  getSpecificConversation(id: string): Observable<any[]> {
    return this.http.get<any>(this.SpecificConversationURL + '/'+ id, httpOptions);
  }
  getJobsByCategory(): Observable<any[]> {
    return this.http.get<any>(this.UsersByCategoryURL + '?type=jobs', httpOptions);
  }
  getFreelancersByCategory(): Observable<any[]> {
    return this.http.get<any>(this.UsersByCategoryURL + '?type=freelancers', httpOptions);
  }
  getAdminSettings(): Observable<any[]> {
    return this.http.get<any>(this.MyAdminSettingsURL, httpOptions);
  }
  getProSetting(): Observable<any[]> {
    return this.http.get<any>(this.ProURL, httpOptions);
  }
  getAllMyChats(): Observable<any[]> {
    return this.http.get<any>(this.MyChatsURL, httpOptions);
  }
  getAllMyNotifications(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.MyNotificationsURL, options);
  }
  getAllUnreadNotifications(): Observable<any[]> {
    return this.http.get<any>(this.AllNotificationCounterURL, httpOptions);
  }
  updateNotification(data: any): Observable<any[]> {
    return this.http.put<any>(this.NotificationsURL + data._id +'/mark_as_read', httpOptions);
  }
  updateReadAllNotification(): Observable<any[]> {
    return this.http.put<any>(this.NotificationsURL + '/mark_all_as_read', httpOptions);
  }
  getSpecificEmployee(id: string): Observable<any[]> {
    return this.http.get<any>(this.AllEmployeesURL + '/' + id, httpOptionsWithOutToken);
  }
  getSpecificEmployer(id: string): Observable<any[]> {
    return this.http.get<any>(this.AllEmployersURL + '/' + id, httpOptions);
  }
  getAllEmployees(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, headers: new HttpHeaders({
      'Accept': 'application/json',
      'skip': 'true'
    }) };
    return this.http.get<any>(this.AllEmployeesURL, options);
  }
  getLeaderboard(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.AllEmployeesURL + '/leader_board', options);
  }
  getEmployeeProfile(): Observable<any[]> {
    return this.http.get<any>(this.EmployeeProfileURL, httpOptions);
  }
  getFavorites(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.FavoriteURL, options);
  }
  getCoinsSettings(): Observable<any[]> {
    return this.http.get<any>(this.CoinsSettingURL, httpOptions);
  }
  getMyPackages(): Observable<any[]> {
    return this.http.get<any>(this.MyPackagesURL, httpOptions);
  }
  getAllPackages(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, headers: new HttpHeaders({
      'Accept': 'application/json',
      'skip': 'true'
    })  };
    return this.http.get<any>(this.PackagesURL, options);
  }
  unsubscribeEmail(): Observable<any[]> {
    return this.http.put<any>(this.UnsubscribeEmailURL, httpOptions);
  }
  buyPackage(data: any): Observable<any[]> {
    return this.http.post<any>(this.BuyPackagesURL,data, httpOptions);
  }
  buyCoin(data: any): Observable<any[]> {
    return this.http.post<any>(this.CoinsURL + '/buy_coin',data, httpOptions);
  }
  transferCoin(data: any): Observable<any[]> {
    return this.http.post<any>(this.CoinsURL + '/transfer_coin',data, httpOptions);
  }
  redeemCoin(data: any): Observable<any[]> {
    return this.http.post<any>(this.CoinsURL + '/redeem',data, httpOptions);
  }
  getMyCoinsTransaction(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.MyCoinsURL, options);
  }
  getMyFreelancerAnalytics(): Observable<any[]> {
    return this.http.get<any>(this.MyFreelancerAnalyticsURL, httpOptions);
  }
  getMyFreelancerApplicationAnalytics(year: string): Observable<any[]> {
    return this.http.get<any>(this.MyFreelancerApplicationAnalyticsURL + '?year=' + year, httpOptions);
  }
  getMyClientAnalytics(): Observable<any[]> {
    return this.http.get<any>(this.MyClientAnalyticsURL, httpOptions);
  }
  getMyContractsByStatus(data: any): Observable<any[]> {
    return this.http.post<any>(this.ContractsURL + '/filter',data, httpOptions);
  }
  getContract(data: any): Observable<any[]> {
    return this.http.get<any>(this.ContractsURL + '/my_contract/' + data , httpOptions);
  }
  disputeContract(data: any): Observable<any[]> {
    return this.http.put<any>(this.RaiseDisputeURL + '/' + data.cid ,data, httpOptions);
  }
  updateContract(data: any): Observable<any[]> {
    return this.http.put<any>(this.ContractsURL + '/' + data.cid ,data, httpOptions);
  }
  requestContractExtension(data: any): Observable<any[]> {
    return this.http.put<any>(this.ContractsURL + '/' + data.cid + '/request_for_extension' ,data, httpOptions);
  }
  getMyContracts(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.MyContractsURL, options);
  }
  updateSetRating(data: any): Observable<any[]> {
    return this.http.put<any>(this.RatingURL + '/' + data.cid, data , httpOptions);
  }
  postMakeAnOffer(data: any): Observable<any[]> {
    return this.http.post<any>(this.OfferURL,data, httpOptions);
  }
  updateOffer(data: any): Observable<any[]> {
    return this.http.put<any>(this.OfferURL + '/' + data.oid, data , httpOptions);
  }
  getOffersIMade(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.AllOffersByEmployeeURL, options);
  }
  getAllOffersIReceived(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.AllOffersToEmployerURL, options);
  }
  getSavedJobs(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.MySavedJobsURL, options);
  }
  saveJobs(data: any): Observable<any[]> {
    return this.http.post<any>(this.SaveJobsURL ,data, httpOptions);
  }
  makeFavorite(data: any): Observable<any[]> {
    return this.http.post<any>(this.FavoriteURL,data, httpOptions);
  }
  getEmployerProfile(): Observable<any[]> {
    return this.http.get<any>(this.EmployerProfileURL, httpOptions);
  }
  updateEmployerProfile(data: any): Observable<any[]> {
    return this.http.put<any>(this.EmployerUpdateProfileURL,data,httpOptions);
  }
  updateEmployeeProfile(data: any): Observable<any[]> {
    return this.http.put<any>(this.EmployeeUpdateProfileURL,data,httpOptions);
  }
  getJobsIAppliedFor(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.JobsIAppliedForURL, options);
  }
  getJobsIAppliedForByStatus(data: any): Observable<any[]> {
    return this.http.post<any>(this.JobsIAppliedByStatusForURL, data, httpOptions);
  }
  applyForJob(proposal: any): Observable<any[]> {
    return this.http.post<any>(this.JobApplyURL, proposal, httpOptions);
  }
  updateApplicantStatus(data: any): Observable<any[]> {
    return this.http.put<any>(this.ApplicantsURL + '/' + data._id, data, httpOptions);
  }
  appliedJobsByStatus(data: any): Observable<any[]> {
    return this.http.post<any>(this.JobApplyByStatusURL, data, httpOptions);
  }
  getAllJobs(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, headers: new HttpHeaders({
      'Accept': 'application/json',
      'skip': 'true'
    }) };
    return this.http.get<any>(this.JobsURL, options);
  }
  jobsIPosted(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.JobsIPostedURL, options);
  }
  hireApplicant(job: { created_by: { _id: any; }; job: { _id: string; }; }): Observable<any[]> {
    var data = {
      "employee":job.created_by._id
    }
    return this.http.post<any>(this.HireApplicantURL + job.job._id, data, httpOptions);
  }
  deleteMyWorkExperience(id: string): Observable<any[]> {
    return this.http.delete<any>(this.MyWorkExperienceURL + '/' + id, httpOptions);
  }

  deleteMyEducation(id: string): Observable<any[]> {
    return this.http.delete<any>(this.MyEducationDataURL + '/' + id, httpOptions);
  }
  getMyJob(id: string): Observable<any[]> {
    return this.http.get<any>(this.JobsURL + '/' + id, httpOptions);
  }
  deleteMyJob(id: string): Observable<any[]> {
    return this.http.delete<any>(this.JobsURL + '/' + id, httpOptions);
  }
  updateMyJob(data: { _id: string; }): Observable<any[]> {
    return this.http.put<any>(this.JobsURL + '/' + data._id, data, httpOptions);
  }
  reportJob(data: any): Observable<any[]> {
    return this.http.put<any>(this.JobsURL + '/' + data._id + '/flag', data, httpOptions);
  }
  postJob(data: any): Observable<any[]> {
    return this.http.post<any>(this.JobsURL,data, httpOptions);
  }
  boostProfile(data: any): Observable<any[]> {
    return this.http.post<any>(this.BoostURL + '/profile', data, httpOptions);
  }
  inviteNewFreelancer(data: any): Observable<any[]> {
    return this.http.post<any>(this.AllEmployeesURL + '/invite',data, httpOptions);
  }
  inviteFreelancer(data: any): Observable<any[]> {
    return this.http.post<any>(this.JobsURL + '/invite_freelancer',data, httpOptions);
  }
  referFreelancer(data: any): Observable<any[]> {
    return this.http.post<any>(this.JobsURL + '/' + data.jobId +'/refer',data, httpOptions);
  }
  getOffersForJob(id: string): Observable<any[]> {
    return this.http.get<any>(this.OfferForJobURL + '/' + id, httpOptions);
  }
  searchEmployees(params: HttpParams | undefined,data: any): Observable<any[]> {
    const options = { params, headers: new HttpHeaders({
      'Accept': 'application/json',
      'skip': 'true'
    }) };
    // avoid sending a top-level `filter` property in the request payload
    const payload = data && typeof data === 'object' ? { ...data } : data;
    if (payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'from')) {
      delete payload.from;
    }
    return this.http.post<any>(this.SearchEmployeesURL, payload, options);
  }
  searchEmployeesByName(data: any): Observable<any[]> {
    return this.http.post<any>(this.SearchEmployeesNameURL,data, httpOptions);
  }
  searchJob(params: HttpParams | undefined,data: any): Observable<any[]> {
    const options = { params, headers: new HttpHeaders({
      'Accept': 'application/json',
      'skip': 'true'
    }) };
    const payload = data && typeof data === 'object' ? { ...data } : data;
    if (payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'from')) {
      delete payload.from;
    }
    return this.http.post<any>(this.SearchJobsURL, payload, options);
  }
  getCategories(params: HttpParams | undefined): Observable<any[]> {
    const options = { params,   headers: new HttpHeaders({
      'Accept': 'application/json',
      'skip': 'true'
    }) };
    return this.http.get<any>(this.CategoriesURL, options);
  }
  getCategoriesSubCategories(id: string): Observable<any[]> {
    return this.http.get<any>(this.CategoriesURL + '/'+ id +'/sub_category', httpOptionsWithOutToken);
  }
  getCategoriesSkillSets(id: string): Observable<any[]> {
    return this.http.get<any>(this.CategoriesURL + '/'+ id +'/skills', httpOptionsWithOutToken);
  }
  getCategoriesJobs(params: HttpParams | undefined, id: string): Observable<any[]> {
    const options = { params, httpOptionsWithOutToken };
    return this.http.get<any>(this.CategoriesURL + '/'+ id +'/jobs', options);
  }
  getSubCategories(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, headers: new HttpHeaders({
      'Accept': 'application/json',
      'skip': 'true'
    }) };
    return this.http.get<any>(this.SubCategoriesURL, options);
  }
  getSkillSets(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, headers: new HttpHeaders({
      'Accept': 'application/json',
      'skip': 'true'
    }) };
    return this.http.get<any>(this.SkillsetsURL, options);
  }
  getEducationLevels(): Observable<any[]> {
    return this.http.get<any>(this.EducationLevelsURL, httpOptionsWithOutToken);
  }
  getMyPendingWallet(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.PendingRechargeWalletURL, options);
  }
  getMyWallet(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.MyWalletURL, options);
  }
  rechargeMyWallet(data: any): Observable<any[]> {
    // const options = { params, httpOptions };
    return this.http.post<any>(this.RechargeMyWalletURL, data, httpOptions);
  }
  makeInvoicePayment(data: any): Observable<any[]> {
    return this.http.post<any>(this.MakeInvoicePaymentURL + data._id + '/pay', data, httpOptions);
  }

  getMyInvoices(params: HttpParams | undefined): Observable<any> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.getMyInvoicesURL, options);
  }
  withdrawBalance(data: any): Observable<any[]> {
    // const options = { params, httpOptions };
    return this.http.post<any>(this.WithdrawBalanceURL, data, httpOptions);
  }
  withdrawBalanceToWise(data: any): Observable<any[]> {
    // const options = { params, httpOptions };
    return this.http.post<any>(this.WithdrawWiseURL, data, httpOptions);
  }
  addWiseAccount(data: any): Observable<any[]> {
    // const options = { params, httpOptions };
    return this.http.post<any>(this.CreateWiseRecipientURL, data, httpOptions);
  }
  addBankAccount(data: any): Observable<any[]> {
    // const options = { params, httpOptions };
    return this.http.post<any>(this.CreateBankRecipientURL, data, httpOptions);
  }
  getMyWise(): Observable<any[]> {
    return this.http.get<any>(this.MyWiseURL, httpOptions);
  }
  getMyBank(): Observable<any[]> {
    return this.http.get<any>(this.MyBankURL, httpOptions);
  }
  removeMyWise(cid: any): Observable<any[]> {
    return this.http.delete<any>(this.BankURL + '/remove_wise?accountId=' + cid, httpOptions);
  }
  removeMyBank(cid: any): Observable<any[]> {
    return this.http.delete<any>(this.BankURL + '/' + cid, httpOptions);
  }
  updateDelivery(data: { did: string; }): Observable<any[]> {
    return this.http.put<any>(this.DeliveryURL + '/' + data.did, data, httpOptions);
  }

  postDelivery(file: any, id: string, message: string):Observable<any[]> {
    const httpOptionsFileUploadDelivery = {
      headers: new HttpHeaders().delete('Content-Type'),
      reportProgress: true,
      observe: 'events' as 'body'
    };
    let formData = new FormData();
    formData.append("file", file);
    formData.append("contract", id);
    formData.append("message", message);
    return this.http.post<any>(this.DeliveryURL,formData,httpOptionsFileUploadDelivery);
  }
  
  uploadEmployerPicture(file: any):Observable<any[]> {
    let formData = new FormData();
    formData.append("picture", file);
    return this.http.put<any>(this.UploadEmployerProfilePicURL,formData,httpOptionsFileUpload);
  }
  uploadEmployeeID(file: any, type: any):Observable<any[]> {
    let httpOptionsFileUpload1 = {
      headers: new HttpHeaders().delete('Content-Type'),
      reportProgress: true,
      observe: 'events' as 'body'
    };
    let formData = new FormData();
    formData.append("picture", file);
    formData.append("name", type);
    return this.http.put<any>(this.UploadEmployeeIDURL +'/1', formData, httpOptionsFileUpload1);
  }
  removeEmployeeCertificate(file:  File):Observable<any[]> {
    let httpOptionsFileUpload1 = {
      headers: new HttpHeaders().delete('Content-Type'),
      reportProgress: true,
      observe: 'events' as 'body'
    };
    let formData = new FormData();
    formData.append('fileName', file);
    return this.http.put<any>(this.UploadEmployeeCerficateURL +'/0', formData, httpOptionsFileUpload1);
  }
  uploadEmployeeCertificate(files:  File[]):Observable<any[]> {
    let httpOptionsFileUpload1 = {
      headers: new HttpHeaders().delete('Content-Type'),
      reportProgress: true,
      observe: 'events' as 'body'
    };
    let formData = new FormData();
    files.forEach(file => {
      formData.append('certificate', file);
    });
    return this.http.put<any>(this.UploadEmployeeCerficateURL +'/1', formData, httpOptionsFileUpload1);
  }


  uploadEmployeePicture(file: any):Observable<any[]> {
    let httpOptionsFileUpload1 = {
      headers: new HttpHeaders().delete('Content-Type'),
      reportProgress: true,
      observe: 'events' as 'body'
    };
    let formData = new FormData();
    formData.append("picture", file);
    return this.http.put<any>(this.UploadEmployeeProfilePicURL, formData, httpOptionsFileUpload1);
  }

  uploadEmployeeResume(file: any):Observable<any[]> {
    let formData = new FormData();
    formData.append("docs", file);
    return this.http.put<any>(this.UploadEmployeResumeURL,formData,httpOptionsFileUpload);
  }

  getAllEndorsments(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.EndorsmentURL + '/myEndorsments', options);
  }

  getAllConnects(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.ConnectsURL + '/allConnection', options);
  }
  getConnectRequests(): Observable<any[]> {
    return this.http.get<any>(this.ConnectsURL + '/myRequests', httpOptions);
  }
  replyConnectRequests(response : any): Observable<any[]> {
    return this.http.patch<any>(this.ConnectsURL + '/' + response._id, response, httpOptions);
  }
  getBlogs(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.BlogsURL + '/' + {}, options);
  }

  getBlog(id: string): Observable<any[]> {
    return this.http.get<any>(this.BlogsURL + '/specific/' + id, httpOptions);
  }

  getSortedBlogs(params: HttpParams | undefined, sort: string): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.BlogsURL + '/' + sort, options);
  }
  getBlogByCategory(filter: any): Observable<any[]> {
    return this.http.post<any>(this.BlogsURL + '/filter_by_category', filter, httpOptions);
  }

  getSearchBlogs(search: any): Observable<any[]> {
    return this.http.post<any>(this.BlogsURL + '/filter',search, httpOptions);
  }

  getMyReferrals(params: HttpParams | undefined): Observable<any[]> {
    const options = { params, httpOptions };
    return this.http.get<any>(this.ReferralURL + '/my_reference', options);
  }
  getActiveChallenges(): Observable<any[]> {
    return this.http.get<any>(this.ChallengeURL + '/my_competition', httpOptions);
  }
  connectFreelancer(data: any): Observable<any[]> {
    return this.http.post<any>(this.ConnectsURL, data, httpOptions);
  }

  becomeAPro(data: any): Observable<any[]> {
    return this.http.post<any>(this.ProURL + '/subscribe/' + data._id, data, httpOptions);
  }

  endorseSkill(data: any): Observable<any[]> {
    return this.http.post<any>(this.EndorsmentURL, data, httpOptions);
  }

  getProBadge() {
    return this.http.get<any>(this.ProURL, httpOptions);
  }
  getProfileViewers() {
    return this.http.get<any>(this.MyProfileViewersURL + '/myViews', httpOptions);
  }


  processProgress(envelope: any): void {
    if (typeof envelope === "number") {
      this.progressSource.next(envelope);
    }
  }

  getEventMessage(event: HttpEvent<any>, file: File) {
    switch (event.type) {
      case HttpEventType.Sent:
        return `Uploading file "${file.name}" of size ${file.size}.`;
      // case HttpEventType.UploadProgress:
      //   return Math.round((100 * event.loaded) / event.total);
      case HttpEventType.Response:
        return `File "${file.name}" was completely uploaded!`;
      default:
        return `File "${file.name}" surprising upload event: ${event.type}.`;
    }
  }

  isEmployee(){
    const role = typeof window !== 'undefined' ? localStorage.getItem('GPROLE') : null;
    if (role == 'employee'){
      this.isUserEmployee = true;
    }else{
      this.isUserEmployee = false;
    }
    return this.isUserEmployee;
  }

  isEmployer(){
    const role = typeof window !== 'undefined' ? localStorage.getItem('GPROLE') : null;
    if (role == 'employer'){
      this.isUserEmployer = true;
    }else{
      this.isUserEmployer = false;
    } 
    return this.isUserEmployer;
  }

  isLoggedin() {
    const loggedIn = typeof window !== 'undefined' ? localStorage.getItem('GPSTATE') : null;
    if (loggedIn == 'true'){
      this.isLoggedIn = true;
      this.isAuthenticatedSrc.next(true);
    }else{
      this.isLoggedIn = false;
      this.isAuthenticatedSrc.next(false);
    }
    return this.isLoggedIn;
  }

  getRole() {
    this.roleAs = typeof window !== 'undefined' ? localStorage.getItem('GPROLE') : null;
    return this.roleAs;
  }

  get isAuthenticated(): Observable<boolean> {
   return this.isAuthenticatedSrc.asObservable();
  }
}
